import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  background: ${({ theme }) => theme.color.white};
  width: 100vw;
  height: 100vh;
`;
